
  import mime from 'mime-types';

  export default {
    props: {
      mediaUrl: { type: String, required: true }
    },
    data () {
      return {
        currentTime: 0,
        dragging: false,
        duration: null,
        media: null,
        mediaType: null,
        playing: false,
        wasPlaying: false
      };
    },
    beforeMount () {
      this.mediaType = mime.lookup(this.mediaUrl).split('/')[0];
    },
    mounted () {
      if (!this.$refs.media) return;
      this.$refs.media.addEventListener('loadedmetadata', e => {
        this.duration = e.target.duration;
        this.$refs.media.addEventListener('timeupdate', this.timeTick);
      });
    },
    methods: {
      drag (e) {
        if (this.dragging) {
          this.$el.querySelector('.progress-bar').style.width = this.percentage(e);
        }
      },
      dragEnd (e) {
        this.dragging = false;
        this.$refs.media.currentTime = this.location(e) * this.$refs.media.duration;
        if (this.wasPlaying) {
          this.$refs.media.play();
        }
      },
      dragStart (e) {
        this.dragging = true;
        this.wasPlaying = !this.$refs.media.paused;
        this.$refs.media.pause();
        this.drag(e);
      },
      location (e) {
        return e.offsetX / this.$el.querySelector('.timer').scrollWidth;
      },
      percentage (e) {
        return this.$n(this.location(e), 'percent');
      },
      playPause () {
        if (!this.$refs.media) return;
        this.playing = !this.playing;
        this.playing ? this.$refs.media.play() : this.$refs.media.pause();
      },
      timeDisplay (seconds) {
        const t = new Date(seconds * 1000).toISOString();
        if (seconds >= 3600) {
          return t.substr(11, 8);
        }
        return t.substr(14, 5);
      },
      timeTick () {
        this.currentTime = this.$refs.media.currentTime;
      }
    }
  };
